<template>
    <div class="call-task" :style="dialogStyle">
        <el-button v-if="showBack" type="primary" size="mini" icon="el-icon-back" @click="$router.back()"
            style="margin-bottom: 0.1rem">返回上一级</el-button>
        <!-- <el-tag type="success" effect="dark" size="mini">
            {{ first_level }}
        </el-tag>
        <el-tag type="warning" effect="dark" size="mini">
            {{ second_level }}
        </el-tag> -->
        <el-breadcrumb separator-class="el-icon-arrow-right">
            <!-- <el-breadcrumb-item :to="{ path: showBack ? 'call_task_c' : 'call_task_m' }">{{ showBack ? '我的外呼任务' : '外呼任务管理' }}</el-breadcrumb-item> -->
            <el-breadcrumb-item><el-tag type="success" effect="dark" size="mini">
                    {{ first_level }}
                </el-tag></el-breadcrumb-item>
            <el-breadcrumb-item><el-tag type="warning" effect="dark" size="mini">
                    {{ second_level }}
                </el-tag></el-breadcrumb-item>
            <!-- <el-breadcrumb-item>活动详情</el-breadcrumb-item> -->
        </el-breadcrumb>
        <el-divider content-position="left">外部资源外呼 -- {{ keyWord }}</el-divider>
        <div class="cal-tas-search-con">
            <div>
                <!-- <select-input :options="first_cate_options" value="source" label="label" placeholder="请选择分类"
                    controller="\App\Controller\Qyh\CallTaskController" method="list" :host="hyperfHost"
                    @createSearch="createSearch" /> -->
                <el-popover placement="bottom-start" v-model="visible">
                    <!-- <el-form :model="searchArr" ref="searchForm" label-width="100px" style="margin-left: -0.3rem">
                        <el-form-item label="客户回复:" width="500px" prop="answer">
                            <el-checkbox v-model="searchArr.answer" border size="mini">客户最新回复消息</el-checkbox>
                        </el-form-item>
                        <!== <el-form-item label="创建时间" prop="created_at">
                            <el-date-picker size="mini" v-model="searchArr.created_at" type="datetimerange"
                                align="right" unlink-panels range-separator="至" start-placeholder="开始日期"
                                end-placeholder="结束日期" :picker-options="ysyTypeInPickerOptions"
                                value-format="yyyy-MM-dd HH:mm:ss" :default-time="['00:00:00', '23:59:59']">
                            </el-date-picker>
                        </el-form-item>==>
                        <el-form-item style="text-align: right; margin-right: 0.3rem">
                            <el-button @click="resetForm('searchForm')" size="mini">重置</el-button>
                            <el-button type="primary" @click="doSearch" size="mini">查询</el-button>
                        </el-form-item>
                    </el-form> -->
                    <Having-Data @doSearch="HandleDoSearch" style="padding-right: 0.5rem" />
                    <el-button slot="reference" size="mini">筛选</el-button>
                </el-popover>
            </div>
            <div style="margin-left: auto; display: flex; justify-content:space-evenly;gap: 0.2rem;">
                <el-button v-if="showBack" type="primary" size="mini"
                    @click.native="openSendSMSDialog($route.params.cate)">
                    <span>发送短信</span>
                    <el-tooltip effect="dark" content="不勾选条目,视为发送给该分类下的全部" placement="top">
                        <i class="el-icon-info"></i>
                    </el-tooltip>
                </el-button>
            </div>
        </div>
        <el-table :height="active_height" v-loading="loading" :data="tableData" style="width: 100%;margin-top: 0.2rem"
            border size="mini" :header-cell-style="{
                background: '#ecf4ff',
                color: '#333',
                fontWeight: '900',
                fontSize: '0.28rem'
            }" element-loading-text="数据加载中" element-loading-spinner="el-icon-loading"
            element-loading-background="rgba(0, 0, 0, 0.4)">
            <el-table-column prop="" label="" width="50" align="center">
                <template slot="header">
                    <el-checkbox v-model="table_choose_all[npage]" @change="handleChooseAllChange"></el-checkbox>
                </template>
                <template slot-scope="scope">
                    <el-checkbox v-model="choose_edit[scope.row.id]"></el-checkbox>
                </template>
            </el-table-column>
            <el-table-column prop="id" label="ID" width="80" align="center">
            </el-table-column>
            <!-- <el-table-column prop="" label="任务分类" width="90" align="center">
                <template slot-scope="scope">
                    <el-tag type="success" effect="dark" size="mini">
                        {{ scope.row.call_cate.first_level }}
                    </el-tag>
                </template>
            </el-table-column> -->
            <!-- <el-table-column prop="" label="任务名称" width="90" align="center">
                <template slot-scope="scope">
                    <el-tag type="warning" effect="dark" size="mini">
                        {{ scope.row.call_cate.name }}
                    </el-tag>
                </template>
            </el-table-column> -->
            <el-table-column prop="assigned_task" label="任务编号" width="95" show-overflow-tooltip align="center">
            </el-table-column>
            <el-table-column prop="company_name" label="公司名称" align="center" width="180" max-width="180"
                show-overflow-tooltip>
                <template slot-scope="scope">
                    <el-link type="primary" @click="openInfoDrawer(scope.row)">{{ scope.row.company_name }}</el-link>
                </template>
            </el-table-column>

            <el-table-column prop="upload_task_info.info.登记状态" label="企业状态" align="center" width="90"
                max-width="90"></el-table-column>
            <el-table-column prop="upload_task_info.info.法定代表人" label="法定代表人" align="center"
                width="90"></el-table-column>
            <el-table-column prop="" label="手机号" align="center" width="205">
                <template slot-scope="scope">
                    <div v-if="scope.row.phone && scope.row.phone.length === 1" class="phone-s-r">
                        <div class="phone-s">
                            <div class="phone-a-c">
                                <phone-com :comPhone="scope.row.phone[0].phone"
                                    :vagaryPhone="Object.hasOwnProperty.call(scope.row.phone[0], 'vagary_phone') ? scope.row.phone[0].vagary_phone : false"
                                    class="phone-com" />
                                <el-tooltip class="item" effect="dark" content="外呼" placement="top">
                                    <i @click="
                                        call(
                                            scope.row.phone[0].vagary_phone ? scope.row.phone[0].vagary_phone : scope.row.phone[0].phone, scope.row.rid
                                        )
                                        " class="el-icon-phone-outline" style="color: #409eff; cursor: pointer; margin-left: 0.1rem"></i>
                                </el-tooltip>
                            </div>
                            <div>
                                <span>
                                    {{ scope.row.phone[0].province }} {{ scope.row.phone[0].city }}
                                </span>
                                <el-tag type="success" effect="dark" size="mini"
                                    v-if="scope.row.phone[0].weixinStatus && scope.row.phone[0].weixinStatus === '活跃号'">
                                    是微信
                                </el-tag>
                                <el-tag type="danger" effect="dark" size="mini"
                                    v-else-if="scope.row.phone[0].weixinStatus && scope.row.phone[0].weixinStatus !== '活跃号'">
                                    {{ scope.row.phone[0].weixinStatus }}
                                </el-tag>
                            </div>
                            <span>
                                手机号姓名: {{ scope.row.phone[0].name }}
                            </span>
                            <!-- <div>
                                <el-popover placement="bottom" width="300" trigger="click" :ref="`mp_${scope.row.id}`">
                                    <mark-position slot="content"/>
                                    <span slot="reference" class="pos-container" @click="showMarkPosition = scope.row.id">职位
                                        <el-tooltip effect="dark" content="点击标记职位,录入姓名" placement="top">
                                            <i class="el-icon-question pos-icon"></i>
                                        </el-tooltip>
                                    </span>
                                </el-popover>
                                <span style="margin-left: 0.2rem">:</span>
                            </div> -->
                        </div>
                        <div>
                            <el-tooltip class="item" effect="dark" content="刷新" placement="top"
                                v-if="scope.row.is_not_refreshed === 1">
                                <i class="el-icon-refresh r-icon r-icon-ref"
                                    @click="loadPhoneInformation(scope.row.resource_id)"></i>
                            </el-tooltip>
                        </div>
                    </div>
                    <div v-if="scope.row.phone && scope.row.phone.length > 1" class="phone-s-r">
                        <div class="phone-s">
                            <div class="phone-a-c">
                                <phone-com class="phone-com" :comPhone="scope.row.phone[0].phone"
                                    :vagaryPhone="Object.hasOwnProperty.call(scope.row.phone[0], 'vagary_phone') ? scope.row.phone[0].vagary_phone : false" />
                                <el-tooltip class="item" effect="dark" content="外呼" placement="top">
                                    <i @click="
                                        call(
                                            scope.row.phone[0].vagary_phone ? scope.row.phone[0].vagary_phone : scope.row.phone[0].phone, scope.row.rid
                                        )
                                        " class="el-icon-phone-outline" style="color: #409eff; cursor: pointer; margin-left: 0.1rem"></i>
                                </el-tooltip>
                            </div>
                            <div>
                                <span>
                                    {{ scope.row.phone[0].province }} {{ scope.row.phone[0].city }}
                                </span>
                                <el-tag type="success" effect="dark" size="mini"
                                    v-if="scope.row.phone[0].weixinStatus && scope.row.phone[0].weixinStatus === '活跃号'">
                                    是微信
                                </el-tag>
                                <el-tag type="danger" effect="dark" size="mini"
                                    v-else-if="scope.row.phone[0].weixinStatus && scope.row.phone[0].weixinStatus !== '活跃号'">
                                    {{ scope.row.phone[0].weixinStatus }}
                                </el-tag>
                            </div>
                            <span>
                                手机号姓名: {{ scope.row.phone[0].name }}
                            </span>
                        </div>
                        <div>
                            <el-tooltip class="item" effect="dark" content="刷新" placement="top"
                                v-if="scope.row.is_not_refreshed === 1">
                                <i class="el-icon-refresh r-icon r-icon-ref"
                                    @click="loadPhoneInformation(scope.row.resource_id)"></i>
                            </el-tooltip>
                            <el-tooltip class="item" effect="dark" content="更多手机号" placement="top">
                                <i class="el-icon-more r-icon r-icon-more" @click="openMorePhone(scope.row.phone)"></i>
                            </el-tooltip>
                        </div>
                    </div>
                </template>
            </el-table-column>
            <el-table-column prop="" label="手机号（渠道拉取）" align="center" width="205">
                <template slot-scope="scope">
                    <div v-if="scope.row.xlb_phone && scope.row.xlb_phone.length === 1" class="phone-s-r">
                        <div class="phone-s">
                            <div class="phone-a-c">
                                <phone-com :comPhone="scope.row.xlb_phone[0].phone"
                                    :vagaryPhone="Object.hasOwnProperty.call(scope.row.xlb_phone[0], 'vagary_phone') ? scope.row.xlb_phone[0].vagary_phone : false"
                                    class="phone-com" />
                                <el-tooltip class="item" effect="dark" content="外呼" placement="top">
                                    <i @click="
                                        call(
                                            scope.row.xlb_phone[0].vagary_phone ? scope.row.xlb_phone[0].vagary_phone : scope.row.xlb_phone[0].phone, scope.row.rid
                                        )
                                        " class="el-icon-phone-outline" style="color: #409eff; cursor: pointer; margin-left: 0.1rem"></i>
                                </el-tooltip>
                            </div>
                            <div>
                                <span>
                                    {{ scope.row.xlb_phone[0].province }} {{
                                    scope.row.xlb_phone[0].city }}
                                </span>
                                <el-tag type="success" effect="dark" size="mini"
                                    v-if="scope.row.xlb_phone[0].weixinStatus && scope.row.xlb_phone[0].weixinStatus === '活跃号'">
                                    是微信
                                </el-tag>
                                <el-tag type="danger" effect="dark" size="mini"
                                    v-else-if="scope.row.xlb_phone[0].weixinStatus && scope.row.xlb_phone[0].weixinStatus !== '活跃号'">
                                    {{ scope.row.xlb_phone[0].weixinStatus }}
                                </el-tag>
                            </div>
                            <span>
                                手机号姓名: {{ scope.row.xlb_phone[0].name }}
                            </span>
                        </div>
                        <div>
                            <el-tooltip class="item" effect="dark" content="刷新" placement="top"
                                v-if="scope.row.is_not_refreshed === 1">
                                <i class="el-icon-refresh r-icon r-icon-ref"
                                    @click="loadPhoneInformation(scope.row.resource_id)"></i>
                            </el-tooltip>
                        </div>
                    </div>
                    <div v-if="scope.row.xlb_phone && scope.row.xlb_phone.length > 1" class="phone-s-r">
                        <div class="phone-s">
                            <div class="phone-a-c">
                                <phone-com class="phone-com" :comPhone="scope.row.xlb_phone[0].phone"
                                    :vagaryPhone="Object.hasOwnProperty.call(scope.row.xlb_phone[0], 'vagary_phone') ? scope.row.xlb_phone[0].vagary_phone : false" />
                                <el-tooltip class="item" effect="dark" content="外呼" placement="top">
                                    <i @click="
                                        call(
                                            scope.row.xlb_phone[0].vagary_phone ? scope.row.xlb_phone[0].vagary_phone : scope.row.xlb_phone[0].phone, scope.row.rid
                                        )
                                        " class="el-icon-phone-outline" style="color: #409eff; cursor: pointer; margin-left: 0.1rem"></i>
                                </el-tooltip>
                            </div>
                            <div>
                                <span>
                                    {{ scope.row.xlb_phone[0].province }} {{
                                    scope.row.xlb_phone[0].city }}
                                </span>
                                <el-tag type="success" effect="dark" size="mini"
                                    v-if="scope.row.xlb_phone[0].weixinStatus && scope.row.xlb_phone[0].weixinStatus === '活跃号'">
                                    是微信
                                </el-tag>
                                <el-tag type="danger" effect="dark" size="mini"
                                    v-else-if="scope.row.xlb_phone[0].weixinStatus && scope.row.xlb_phone[0].weixinStatus !== '活跃号'">
                                    {{ scope.row.xlb_phone[0].weixinStatus }}
                                </el-tag>
                            </div>
                            <span>
                                手机号姓名: {{ scope.row.xlb_phone[0].name }}
                            </span>
                        </div>
                        <div>
                            <el-tooltip class="item" effect="dark" content="刷新" placement="top"
                                v-if="scope.row.is_not_refreshed === 1">
                                <i class="el-icon-refresh r-icon r-icon-ref"
                                    @click="loadPhoneInformation(scope.row.resource_id)"></i>
                            </el-tooltip>
                            <el-tooltip class="item" effect="dark" content="更多手机号" placement="top">
                                <i class="el-icon-more r-icon r-icon-more"
                                    @click="openMorePhone(scope.row.xlb_phone)"></i>
                            </el-tooltip>
                        </div>
                    </div>
                </template>
            </el-table-column>
            <el-table-column prop="" label="手机号（清洗后）" align="center" width="205">
                <template slot-scope="scope">
                    <div v-if="scope.row.self_phone && scope.row.self_phone.length === 1" class="phone-s-r">
                        <div class="phone-s">
                            <div class="phone-a-c">
                                <phone-com :comPhone="scope.row.self_phone[0].phone"
                                    :vagaryPhone="Object.hasOwnProperty.call(scope.row.self_phone[0], 'vagary_phone') ? scope.row.self_phone[0].vagary_phone : false"
                                    class="phone-com" />
                                <el-tooltip class="item" effect="dark" content="外呼" placement="top">
                                    <i @click="
                                        call(
                                            scope.row.self_phone[0].vagary_phone ? scope.row.self_phone[0].vagary_phone : scope.row.self_phone[0].phone, scope.row.rid
                                        )
                                        " class="el-icon-phone-outline" style="color: #409eff; cursor: pointer; margin-left: 0.1rem"></i>
                                </el-tooltip>
                            </div>
                            <div>
                                <span>
                                    {{ scope.row.self_phone[0].province }} {{
                                        scope.row.self_phone[0].city }}
                                </span>
                                <el-tag type="success" effect="dark" size="mini"
                                    v-if="scope.row.self_phone[0].weixinStatus && scope.row.self_phone[0].weixinStatus === '活跃号'">
                                    是微信
                                </el-tag>
                                <el-tag type="danger" effect="dark" size="mini"
                                    v-else-if="scope.row.self_phone[0].weixinStatus && scope.row.self_phone[0].weixinStatus !== '活跃号'">
                                    {{ scope.row.self_phone[0].weixinStatus }}
                                </el-tag>
                            </div>
                            <span>
                                手机号姓名: {{ scope.row.self_phone[0].name }}
                            </span>
                            <span>
                                职位: {{ scope.row.self_phone[0].position.join('、') }}
                            </span>
                        </div>
                        <div>
                            <el-tooltip class="item" effect="dark" content="刷新" placement="top"
                                v-if="scope.row.is_not_refreshed === 1">
                                <i class="el-icon-refresh r-icon r-icon-ref"
                                    @click="loadPhoneInformation(scope.row.resource_id)"></i>
                            </el-tooltip>
                        </div>
                    </div>
                    <div v-if="scope.row.self_phone && scope.row.self_phone.length > 1" class="phone-s-r">
                        <div class="phone-s">
                            <div class="phone-a-c">
                                <phone-com class="phone-com" :comPhone="scope.row.self_phone[0].phone"
                                    :vagaryPhone="Object.hasOwnProperty.call(scope.row.self_phone[0], 'vagary_phone') ? scope.row.self_phone[0].vagary_phone : false" />
                                <el-tooltip class="item" effect="dark" content="外呼" placement="top">
                                    <i @click="
                                        call(
                                            scope.row.self_phone[0].vagary_phone ? scope.row.self_phone[0].vagary_phone : scope.row.self_phone[0].phone, scope.row.rid
                                        )
                                        " class="el-icon-phone-outline" style="color: #409eff; cursor: pointer; margin-left: 0.1rem"></i>
                                </el-tooltip>
                            </div>
                            <div>
                                <span>
                                    {{ scope.row.self_phone[0].province }} {{
                                        scope.row.self_phone[0].city }}
                                </span>
                                <el-tag type="success" effect="dark" size="mini"
                                    v-if="scope.row.self_phone[0].weixinStatus && scope.row.self_phone[0].weixinStatus === '活跃号'">
                                    是微信
                                </el-tag>
                                <el-tag type="danger" effect="dark" size="mini"
                                    v-else-if="scope.row.self_phone[0].weixinStatus && scope.row.self_phone[0].weixinStatus !== '活跃号'">
                                    {{ scope.row.self_phone[0].weixinStatus }}
                                </el-tag>
                            </div>
                            <span>
                                手机号姓名: {{ scope.row.self_phone[0].name }}
                            </span>
                            <span>
                                职位: {{ scope.row.self_phone[0].position.join('、') }}
                            </span>
                        </div>
                        <div>
                            <el-tooltip class="item" effect="dark" content="刷新" placement="top"
                                v-if="scope.row.is_not_refreshed === 1">
                                <i class="el-icon-refresh r-icon r-icon-ref"
                                    @click="loadPhoneInformation(scope.row.resource_id)"></i>
                            </el-tooltip>
                            <el-tooltip class="item" effect="dark" content="更多手机号" placement="top">
                                <i class="el-icon-more r-icon r-icon-more"
                                    @click="openMorePhone(scope.row.self_phone)"></i>
                            </el-tooltip>
                        </div>
                    </div>
                </template>
            </el-table-column>
            <el-table-column prop="" label="座机号" align="center" width="145">
                <template slot-scope="scope">
                    <div style="display: flex;align-items: center;justify-content: space-between;">
                        <div style="display:flex;flex-direction: column;"
                            v-if="scope.row.more_phone && scope.row.more_phone.length">
                            <span v-for="(item, index) in scope.row.more_phone[0]" :key="index">
                                <em>{{ Array.isArray(item) ? item.join('\n') : item }}</em>
                            </span>
                        </div>
                        <div v-if="scope.row.more_phone && scope.row.more_phone.length >= 2"
                            style="text-align: center;">
                            <el-tooltip class="item" effect="dark" content="更多座机号" placement="top">
                                <i class="el-icon-more r-icon r-icon-more"
                                    @click="openMoreFixedPhone(scope.row.more_phone)"></i>
                            </el-tooltip>
                        </div>
                    </div>
                </template>
            </el-table-column>
            <el-table-column prop="" label="会员/订单" align="center" width="110">
                <template slot-scope="scope">
                    <!-- <p>
                        是否会员:
                        <el-tag v-if="scope.row.is_member_is_order.member.length" type="success" size="mini" effect="dark">是</el-tag>
                        <el-tag v-else type="danger" size="mini" effect="dark">否</el-tag>
                    </p>
                    <p>
                        是否订单:
                        <el-tag v-if="scope.row.is_member_is_order.order.length" type="success" size="mini" effect="dark">是</el-tag>
                        <el-tag v-else type="danger" size="mini" effect="dark">否</el-tag>
                    </p> -->
                    <p>
                        是否会员:
                        <el-tag v-if="scope.row.user_id" type="success" size="mini" effect="dark">是</el-tag>
                        <el-tag v-else type="danger" size="mini" effect="dark">否</el-tag>
                    </p>
                    <p>
                        是否订单:
                        <el-tag v-if="scope.row.order_id" type="success" size="mini" effect="dark">是</el-tag>
                        <el-tag v-else type="danger" size="mini" effect="dark">否</el-tag>
                    </p>
                </template>
            </el-table-column>
            <el-table-column prop="assigned_at" label="分配时间" align="center" width="">
            </el-table-column>
            <el-table-column label="操作" fixed="right" width="165">
                <template slot-scope="scope">
                    <el-tooltip class="item" effect="dark" content="反馈" placement="top">
                        <el-button @click="openFeed(scope.row)" type="primary" size="mini" icon="el-icon-notebook-2"
                            circle>
                        </el-button>
                    </el-tooltip>
                    <el-tooltip class="item" effect="dark" content="客户回复短信最新消息" placement="top">
                        <el-button @click="openDrawer_smsHistory(scope.row)" type="primary" size="mini"
                            icon="el-icon-chat-line-square" circle>
                        </el-button>
                    </el-tooltip>
                    <el-dropdown style="margin-left: 0.2rem">
                        <span class="el-dropdown-link">
                            更多<i class="el-icon-arrow-down el-icon--right"></i>
                        </span>
                        <el-dropdown-menu slot="dropdown">
                            <el-dropdown-item icon="el-icon-message"
                                @click.native="handleOpenSingleMessageDrawer(scope.row)">发送短信</el-dropdown-item>
                            <el-dropdown-item icon="el-icon-edit-outline"
                                @click.native="openDrawer_typeInPhone(scope.row)">录入手机号</el-dropdown-item>
                        </el-dropdown-menu>
                    </el-dropdown>
                </template>
            </el-table-column>
        </el-table>
        <div style="text-align: right;">
            <pagination-com :total="total" :perPage="pageSize" :npage="npage" @handleSizeChange="handleSizeChange"
                @handleCurrentChange="handleCurrentChange" />
        </div>

        <el-dialog :visible.sync="dialog" @closeDialog="closeDialog" @beforeCloseDialog="beforeCloseDialog"
            append-to-body width="40%" center>
            <template v-slot:title>
                <span class="dia-title">
                    更多手机号
                </span>
            </template>
            <div style="text-align: center;">
                <more-phone :options="leftPhone" />
            </div>
        </el-dialog>

        <el-dialog :visible.sync="dialogFixedPhone" @closeDialog="closeDialogFixedPhone"
            @beforeCloseDialog="beforeCloseDialogFixedPhone" width="40%" center append-to-body>
            <template v-slot:title>
                <span class="dia-title">
                    更多座机号
                </span>
            </template>
            <div style="text-align: center;">
                <more-fixed :options="leftPhoneFixed" />
            </div>
        </el-dialog>

        <el-drawer :visible.sync="feedDrawer" direction="rtl" :before-close="handleUpdateClose" size="50%"
            append-to-body>
            <template slot="title">
                <span style="color:#409eff;font-size:medium">反馈</span>
            </template>
            <!-- <div style="padding: 0 0.2rem"> -->
            <feed-back v-if="feedDrawer" style="padding: 0 0.2rem; height: 95vh;overflow: auto;" :orderId="tableId"
                :type="10" :isShow="true" :cType="39" @reflectCompleted="reflectCompleted" />
            <!-- </div> -->

        </el-drawer>

        <el-drawer :visible.sync="smsLogDrawer" direction="rtl" :before-close="handleBeforeCloseSmsLogDrawer"
            @close="handleCloseSmsLogDrawer" size="50%" append-to-body>
            <template slot="title">
                <span style="color:#409eff;font-size:medium">最新未读短信消息</span>
            </template>
            <sms-log style="padding: 0 0.2rem 0.2rem 0.2rem;" :id="row_id" />
        </el-drawer>

        <el-drawer :visible.sync="typeInPhoneDrawer" direction="rtl" :before-close="handleBeforeCloseTypeInPhoneDrawer"
            @close="handleCloseTypeInPhoneDrawer" size="50%" append-to-body>
            <template slot="title">
                <span style="color:#409eff;font-size:medium">录入手机号</span>
            </template>
            <div v-if="typeInPhoneDrawer" style="padding: 0 0.2rem 0.2rem 0.2rem;height: 100vh;overflow: scroll">
                <type-in-phone ref="typeInPhone" v-for="(item, index) in typeInPhoneArr" :phoneArr="typeInPhoneArr"
                    :key="item.id" :index="index" @addModule=addModule @delModule="delModule"
                    style="margin-top: 0.2rem" />
                <div style="text-align: right;padding-top: 0.2rem;margin-bottom: 1.5rem">
                    <el-button type="primary" size="mini" @click="submitAddPhoneForm">提 交</el-button>
                </div>
            </div>
        </el-drawer>

        <el-dialog :visible.sync="dialog_sms" @closeDialog="closeDialog_sms" @beforeCloseDialog="beforeCloseDialog_sms"
            width="40%" center>
            <template v-slot:title>
                <span class="dia-title">
                    发送短信
                </span>
            </template>
            <div class="cal-tas-m-bg-con">
                <send-s-m-s :cate="smsId" :kw="kw" :callTaskIds="choose_edit" />
            </div>
        </el-dialog>

        <el-drawer :visible.sync="singleMessageDrawer" direction="rtl"
            :before-close="handleBeforeCloseSingleMessageDrawer" @close="handleCloseSingleMessageDrawer" size="50%"
            append-to-body>
            <template slot="title">
                <span style="color:#409eff;font-size:medium">发送短信</span>
            </template>
            <div v-if="singleMessageDrawer" style="padding: 0 0.2rem 0.2rem 0.2rem;height: 100vh;overflow: scroll">
                <SingleMessage>
                    <template v-slot:check>
                        <CheckReverse ref="phone" :options="allPhoneOptions" label="phone" show="phone"
                            :tooltip="true" />
                    </template>
                    <template v-slot:message>
                        <MessageContent ref="msgContent" :task_id="singleMessage_id"
                            :company_name="singleMessage_company_name" />
                    </template>
                </SingleMessage>
                <div style="text-align: right;padding-top: 0.2rem;margin-bottom: 0.5rem">
                    <el-button type="primary" size="mini" @click="handleSendSingleMessage">发 送</el-button>
                </div>
                <div style="text-align: center;font-size:medium;margin-bottom: 0.2rem">短信记录</div>
                <sms-log style="padding: 0 0.2rem 0.2rem 0.2rem;margin-bottom: 1.5rem" :id="singleMessage_id"
                    :all="true" />
            </div>
        </el-drawer>

        <el-drawer :visible.sync="infoDrawer" direction="rtl" :before-close="handleBeforeCloseInfoDrawer"
            @close="handleCloseInfoDrawer" size="50%" append-to-body>
            <template slot="title">
                <span style="color:#409eff;font-size:medium">{{ infoId }}</span>
            </template>
            <!-- <company-info style="padding: 0 0.2rem 0.2rem 0.2rem;" :call_task_id="infoId" /> -->
            <company-info-new style="padding: 0 0.2rem 0.2rem 0.2rem;" :companyName="infoId" />
        </el-drawer>

        <el-drawer :visible.sync="setCustomerMeanDrawer" direction="rtl"
            :before-close="handleBeforeCloseSetCustomerMeanDrawer" @close="handleCloseSetCustomerMeanDrawer" size="50%"
            append-to-body>
            <template slot="title">
                <span style="color:#409eff;font-size:medium">设为高意向客户</span>
            </template>
            <set-as-high-intent-customer />
        </el-drawer>
    </div>
</template>

<script>
import PaginationCom from '../../commonReform/PaginationCom';
import PhoneCom from "common/PhoneCom";
import MorePhone from './Components/MorePhone';
import MoreFixed from './Components/MoreFixed';
import FeedBack from '../../common/FeedBack';
import SendSMS from './Components/SendSMS';
import SmsLog from './Components/SmsLog.vue';
import TypeInPhone from './Components/TypeInPhone.vue';
import { nanoid } from 'nanoid'
import MarkPosition from './Components/MarkPosition';
import HavingData from './Components/HavingData'
import SingleMessage from './Components/SingleMessage';
import CheckReverse from '../../commonReform/CheckReverse';
import MessageContent from './Components/MessageContent';
import CompanyInfo from './Components/CompanyInfo';
import CompanyInfoNew from '../company_risks/common/CompanyInfo';
export default {
    name: 'CallTask',
    components: {
        PaginationCom, PhoneCom, MorePhone, MoreFixed, FeedBack, SendSMS, SmsLog, TypeInPhone, MarkPosition, HavingData, SingleMessage, CheckReverse, MessageContent, CompanyInfo, CompanyInfoNew
    },
    props: {
        t_keyword: {
            type: String
        },
        manage: {
            type: Object
        },
    },
    data() {
        return {
            tableData: [],
            pageSize: 30,
            total: 0,
            npage: 1,
            hyperfHost:
                process.env.NODE_ENV === "development"
                    ? "http://127.0.0.1:9501/v1/"
                    : "https://qyh-next-server.zhang66.cn/v1/",
            dialog: false,
            leftPhone: [],
            dialogFixedPhone: false,
            leftPhoneFixed: [],
            feedDrawer: false,
            tableId: '',
            keyWord: '',
            manageData: {},
            showBack: true,
            kw: '',
            active_height: 'calc(100vh - 5.5rem)',
            table_choose_all: {},
            choose_edit: {},
            smsId: '',
            dialog_sms: false,
            row_id: null,
            smsLogDrawer: false,
            visible: false,
            searchArr: {},
            row_id_typeIn: null,
            typeInPhoneDrawer: false,
            typeInPhoneArr: [],
            positionPop: null,
            first_level: sessionStorage['ysyCallTaskLevelF'] ? sessionStorage['ysyCallTaskLevelF'] : '',
            second_level: sessionStorage['ysyCallTaskLevelS'] ? sessionStorage['ysyCallTaskLevelS'] : '',
            showMarkPosition: null,
            singleMessageDrawer: false,
            allPhoneOptions: [],
            singleMessage_id: null,
            singleMessage_company_name: '',
            loading: true,
            rt_id: null,
            infoId: null,
            infoDrawer: false,
            setCustomerMeanDrawer: false
        }
    },
    methods: {
        loadTable() {
            if (!this.showBack) {
                this.kw = this.manageData.keyword
            } else {
                this.kw = this.$route.params.keyword
            }
            this.loading = true
            this.$axios.get(`${this.hyperfHost}api/call_task/call_list?page=${this.npage}`, {
                loadingClose: true,
                params: {
                    perPage: this.pageSize,
                    cate: this.$route.params.cate,
                    // keyword: this.$route.params.keyword,
                    searchArr: this.searchArr,
                    keyword: this.kw,
                    manage: this.manageData
                },
            }).then(({ data }) => {
                if (data.code === 0) {
                    this.loading = false
                    this.tableData = data.data.data
                    this.total = data.data.total
                }
            }).catch()
        },
        setKeyWord() {
            const params = this.$route.params
            const level = JSON.parse(params.other)
            this.keyWord = params.tword
            this.first_level = level.first_level
            this.second_level = level.second_level
        },
        handleSizeChange(val) {
            this.npage = 1;
            this.pageSize = val;
            this.loadTable();
        },
        handleCurrentChange(val) {
            this.npage = val;
            this.loadTable();
        },
        openMorePhone(phone) {
            this.leftPhone = phone.slice(1);
            this.dialog = true
        },
        openMoreFixedPhone(phone) {
            this.leftPhoneFixed = phone.slice(1);
            this.dialogFixedPhone = true
        },
        closeDialog() {
            this.leftPhone = []
        },
        beforeCloseDialog() {

        },
        closeDialogFixedPhone() {
            this.leftPhoneFixed = []
        },
        beforeCloseDialogFixedPhone() {

        },
        async call(phone, id) {
            if (!phone) {
                this.$message.error("手机号为空");
                return;
            }

            const { Method_outCall } = await import('@/Methods')

            Method_outCall.call(this, phone, id)

            // this.$axios.post("/api/admin/call_logs/" + num).then((res) => {
            // this.$axios
            //     .post("api/admin/call_logs_call", {
            //         phone,
            //     })
            //     .then((res) => {
            //         let { data } = res;
            //         if (data.code === 0) {
            //             this.$message.success("调用成功，请注意接听来电");
            //             setTimeout(this.getCallLogs(this.order.customer_phone), 500);
            //         } else {
            //             this.$message.error(data.msg);
            //         }
            //     });
        },
        loadPhoneInformation(id) {
            this.$axios.get('/api/api3_call_task/refresh_phone_info', {
                params: {
                    id
                }
            }).then(({ data }) => {
                if (data.code === 0) {
                    this.loadTable()
                } else {
                    this.$message.error(data.message)
                }
            }).catch()
        },
        openFeed(row) {
            this.tableId = row.rid
            this.feedDrawer = true
        },
        openDrawer_smsHistory(row) {
            this.row_id = row.resource_id
            this.smsLogDrawer = true
        },
        openDrawer_typeInPhone(row) {
            this.row_id_typeIn = row.resource_id
            this.typeInPhoneDrawer = true
        },
        handleUpdateClose(done) {
            done();
        },
        handleBeforeCloseSmsLogDrawer(done) {
            done();
        },
        handleCloseSmsLogDrawer() {
            this.row_id = null
        },
        handleBeforeCloseTypeInPhoneDrawer(done) {
            done();
        },
        handleCloseTypeInPhoneDrawer() {
            this.initTypeInPhoneData()
        },
        handleBeforeCloseSingleMessageDrawer(done) {
            done();
        },
        handleCloseSingleMessageDrawer() {
            this.initSingleMessageData()
        },
        initSingleMessageData() {
            this.singleMessage_id = null
            this.singleMessage_company_name = ''
            this.allPhoneOptions = []
        },
        initTypeInPhoneData() {
            this.row_id_typeIn = null
            this.typeInPhoneArr = []
            this.addModule(0)
        },
        openSendSMSDialog(id) {
            this.smsId = id
            this.dialog_sms = true
        },
        closeDialog_sms() {
            this.smsId = ''
        },
        beforeCloseDialog_sms() {

        },
        handleChooseAllChange(val) {
            if (val) {
                this.$set(this.table_choose_all, this.npage, true)
                this.tableData.map(item => {
                    this.$set(this.choose_edit, item.id, true)
                })
            } else {
                this.$set(this.table_choose_all, this.npage, false)
                this.tableData.map(item => {
                    this.$set(this.choose_edit, item.id, false)
                })
            }
        },
        resetForm(formName) {
            this.$refs[formName].resetFields();
        },
        doSearch() {
            this.npage = 1;
            this.visible = false;
            this.loadTable();
        },
        HandleDoSearch(data) {
            this.searchArr = data
            this.npage = 1;
            this.visible = false;
            this.loadTable();
        },
        addModule(index) {
            this.typeInPhoneArr.splice(index + 1, 0, { id: nanoid() })
        },
        delModule(index) {
            this.typeInPhoneArr.splice(index, 1)
        },
        submitAddPhoneForm() {
            const phoneData = []
            this.$refs.typeInPhone.map(item => {
                phoneData.push(item.selfPhone)
            })
            this.$axios.post('/api/api3_call_task/store_self_phone', {
                id: this.row_id_typeIn,
                phoneData
            }).then(({ data }) => {
                if (data.code === 0) {
                    this.typeInPhoneDrawer = false
                    this.loadTable()
                } else {
                    this.$message.error(data.msg)
                }
            }).catch()
        },
        showPositionPop(id) {
            this.positionPop = id
        },
        clickPop(item) {
            // 这个操作是为了避免与源码中的点击reference doToggle方法冲突
            if (this.activeId === item && this.showPop) return
            this.showPop = false
            this.activeId = item
            // 因为reference是需要获取dom的引用 所以需要是$el
            this.reference = this.$refs['bt' + item][0].$el
            console.log(this.$refs['bt' + item], 'el')
            this.$nextTick(() => {
                // 等待显示的popover销毁后再 重新渲染新的popover
                this.showPop = true
                this.$nextTick(() => {
                    // 此时才能获取refs引用
                    this.$refs.pop.doShow()
                })
            })
        },
        handleOpenSingleMessageDrawer(row) {
            if (row.phone) {
                row.phone.map(item => {
                    this.allPhoneOptions.push({
                        name: item.name,
                        phone: item.phone,
                        position: item.position,
                        tooltip_content: `姓名:${item.name} ${item.position ? item.position.join('、') : ''}`
                    })
                })
            }
            if (row.xlb_phone) {
                row.xlb_phone.map(item => {
                    this.allPhoneOptions.push({
                        name: item.name,
                        phone: item.phone,
                        position: item.position,
                        tooltip_content: `姓名:${item.name} ${item.position ? item.position.join('、') : ''}`
                    })
                })
            }
            if (row.self_phone) {
                row.self_phone.map(item => {
                    this.allPhoneOptions.push({
                        name: item.name,
                        phone: item.phone,
                        position: item.position,
                        tooltip_content: `姓名:${item.name} ${item.position ? item.position.join('、') : ''}`
                    })
                })
            }
            this.singleMessage_id = row.resource_id
            this.rt_id = row.id
            this.singleMessage_company_name = row.company_name
            this.singleMessageDrawer = true
        },
        handleSendSingleMessage() {
            let message = this.$refs.msgContent.message
            let type = this.$refs.msgContent.type
            let template_id = this.$refs.msgContent.template_id
            let phone = this.$refs.phone.checkList
            if (!phone.length) {
                this.$message.error('没有选择手机号!')
                return false
            }
            if (message.length > 70) {
                this.$message.warning('短信字数超过了限制!')
                return false
            }
            if (type === '1') {
                if (!message.length) {
                    this.$message.error('短信内容是不是忘记填写了?')
                    return false
                }
            }
            if (type === '2') {
                if (!template_id) {
                    this.$message.error('短信模版没有选择!')
                    return false
                }
            }
            this.$axios.get('/api/api3_call_task/send_single_message', {
                params: {
                    phone,
                    call_task_id: this.singleMessage_id,
                    rt_id: this.rt_id,
                    msgContentData: {
                        type,
                        template_id,
                        message
                    }
                }
            }).then(({ data }) => {
                if (data.code === 0) {
                    this.$message.success(data.msg)
                    this.singleMessageDrawer = false
                } else {
                    this.$message.error(data.msg)
                }
            }).catch()
        },
        openInfoDrawer(row) {
            this.infoId = row.company_name
            this.infoDrawer = true
        },
        handleBeforeCloseInfoDrawer(done) {
            done();
        },
        handleCloseInfoDrawer() {
            this.infoId = null
        },
        handleBeforeCloseSetCustomerMeanDrawer(done) {
            done();
        },
        handleCloseSetCustomerMeanDrawer() {
            // this.infoId = null
        },
        openDrawer_setCustomerMeanDrawer() {
            this.setCustomerMeanDrawer = true
        },
        reflectCompleted(data) {
            this.tableData = this.tableData.filter(item => item.rid !== data)
            this.feedDrawer = false
        }
    },
    created() {
    },
    mounted() {
        this.addModule(0)
        if (!this.showBack) return false
        this.setKeyWord()
        this.loadTable()
    },
    beforeDestroy() {
        this.first_level = ''
        this.second_level = ''
        // delete sessionStorage['ysyCallTaskLevelF']
        // delete sessionStorage['ysyCallTaskLevelS']
    },
    watch: {
        t_keyword: {
            immediate: true,
            handler(n) {
                if (n) {
                    this.keyWord = n
                    this.active_height = 'calc(100vh - 4.5rem)'
                    this.showBack = false
                }
            }
        },
        manage: {
            immediate: true,
            handler(n) {
                this.manageData = n
                if (n && JSON.stringify(n) !== '{}') {
                    this.loadTable()
                }
            }
        }
    },
    computed: {
        dialogStyle() {
            return {
                padding: !this.showBack ? '0rem' : '1.82rem 0.4rem 0.4rem 0.4rem'
            }
        },
    }
}
</script>

<style scoped>
.call-task {
    padding: 1.82rem 0.4rem 0.4rem 0.4rem;
}

.call-task .cal-tas-search-con {
    display: flex;
    align-items: center;
}

.call-task .phone-s {
    display: flex;
    align-items: flex-start;
    /* justify-content: space-evenly; */
    justify-content: center;
    flex-direction: column;
}

.call-task .phone-com {
    margin-left: -0.1rem;
}

.call-task .phone-s-r {
    display: flex;
    align-items: center;
    /* justify-content: space-evenly; */
    justify-content: space-between;
    flex-direction: row;
    /* gap: 0.1rem; */
}

.call-task .r-icon {
    cursor: pointer;
}

.call-task .r-icon-ref {
    color: #409EFF;
}

.call-task .r-icon-more {
    color: #E6A23C;
}

.call-task .dia-title {
    font-size: large;
    font-weight: bold;
    color: #409EFF;
}

.call-task .phone-a-c {
    display: flex;
    align-items: center;
    justify-content: space-evenly;
    flex-direction: row;
}

.call-task>>>.el-dialog {
    display: flex;
    flex-direction: column;
    margin: 0 !important;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    /*height:600px;*/
    max-height: calc(100% - 200px);
    max-width: calc(100% - 30px);
    box-shadow: 0 15px 30px rgba(0, 0, 0, .3);
}

.call-task>>>.el-dialog .el-dialog__body {
    flex: 1;
    overflow: auto;
}

/* .el-drawer__wrapper>>>.el-drawer {
  overflow-y: auto;
} */

.call-task .dia-title {
    font-size: large;
    font-weight: bold;
    color: #409EFF;
}

.call-task .cal-tas-m-bg-con {
    display: flex;
    flex-direction: column;
    justify-content: space-evenly;
    align-items: center;
}

.call-task .el-dropdown-link {
    cursor: pointer;
    color: #409EFF;
}

.call-task .el-icon-arrow-down {
    font-size: 12px;
}

.call-task .pos-container {
    position: relative;
    cursor: pointer;
}

.call-task .pos-icon {
    position: absolute;
    top: 8px;
    right: -9px;
    transform: translateY(-100%);
}
</style>


// WEBPACK FOOTER //
// src/pages/cloudClue/CallTask.vue